module.exports = __webpack_public_path__ + "static/img/LOGO.76ea796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LOGO.png
// module id = aH4J
// module chunks = 18